export const SOURCE_ID = "organizations";
export const LAYER_CLUSTERS_ID = "organizations-clusters";
export const LAYER_CLUSTER_COUNT_ID = "organizations-cluster-count";
export const LAYER_POINTS_ID = "organizations-points";
export const LAYER_HIGHLIGHT_ID = "organizations-highlight";
export const LAYER_CLUSTER_HIGHLIGHT_ID = "organizations-cluster-highlight";
export const USER_LOCATION_SOURCE_ID = "user-location";
export const USER_LOCATION_LAYER_ID = "user-location-layer";

export const BOUNDARY_SOURCE_ID = "tulsa-zip-boundaries";
export const BOUNDARY_FILL_LAYER_ID = "tulsa-zip-boundaries-fill";
export const BOUNDARY_LINE_LAYER_ID = "tulsa-zip-boundaries-outline";
export const BOUNDARY_HIGHLIGHT_FILL_LAYER_ID = "tulsa-zip-boundaries-highlight-fill";
export const BOUNDARY_HIGHLIGHT_LINE_LAYER_ID = "tulsa-zip-boundaries-highlight-line";
export const BOUNDARY_PINNED_FILL_LAYER_ID = "tulsa-zip-boundaries-pinned-fill";
export const BOUNDARY_PINNED_LINE_LAYER_ID = "tulsa-zip-boundaries-pinned-line";
export const BOUNDARY_HOVER_LINE_LAYER_ID = "tulsa-zip-boundaries-hover-line";
export const BOUNDARY_HOVER_FILL_LAYER_ID = "tulsa-zip-boundaries-hover-fill";
export const BOUNDARY_STATDATA_FILL_LAYER_ID = "tulsa-zip-statdata-fill";

export const COUNTY_BOUNDARY_SOURCE_ID = "oklahoma-county-boundaries";
export const COUNTY_BOUNDARY_FILL_LAYER_ID = "oklahoma-county-boundaries-fill";
export const COUNTY_BOUNDARY_LINE_LAYER_ID = "oklahoma-county-boundaries-outline";
export const COUNTY_BOUNDARY_HOVER_FILL_LAYER_ID = "oklahoma-county-boundaries-hover-fill";
export const COUNTY_BOUNDARY_HOVER_LINE_LAYER_ID = "oklahoma-county-boundaries-hover-line";
export const COUNTY_BOUNDARY_HIGHLIGHT_FILL_LAYER_ID = "oklahoma-county-boundaries-highlight-fill";
export const COUNTY_BOUNDARY_HIGHLIGHT_LINE_LAYER_ID = "oklahoma-county-boundaries-highlight-line";
export const COUNTY_BOUNDARY_PINNED_FILL_LAYER_ID = "oklahoma-county-boundaries-pinned-fill";
export const COUNTY_BOUNDARY_PINNED_LINE_LAYER_ID = "oklahoma-county-boundaries-pinned-line";
export const COUNTY_STATDATA_FILL_LAYER_ID = "oklahoma-county-statdata-fill";

export const ZIP_CENTROIDS_SOURCE_ID = "tulsa-zip-centroids";
export const SECONDARY_STAT_LAYER_ID = "tulsa-zip-secondary-stat-overlay";
export const SECONDARY_STAT_HOVER_LAYER_ID = "tulsa-zip-secondary-stat-overlay-hover";
export const ZIP_STAT_EXTREME_HIGH_LAYER_ID = "tulsa-zip-stat-extreme-high";
export const ZIP_STAT_EXTREME_LOW_LAYER_ID = "tulsa-zip-stat-extreme-low";
export const POINTS_OF_INTEREST_SOURCE_ID = "points-of-interest";
export const ZIP_POI_EXTREME_HIGH_LAYER_ID = "tulsa-zip-poi-extreme-high";
export const ZIP_POI_EXTREME_LOW_LAYER_ID = "tulsa-zip-poi-extreme-low";
export const COUNTY_CENTROIDS_SOURCE_ID = "oklahoma-county-centroids";
export const COUNTY_SECONDARY_LAYER_ID = "oklahoma-county-secondary-stat-overlay";
export const COUNTY_SECONDARY_HOVER_LAYER_ID = "oklahoma-county-secondary-stat-overlay-hover";
export const COUNTY_STAT_EXTREME_HIGH_LAYER_ID = "oklahoma-county-stat-extreme-high";
export const COUNTY_STAT_EXTREME_LOW_LAYER_ID = "oklahoma-county-stat-extreme-low";
export const COUNTY_POI_EXTREME_HIGH_LAYER_ID = "oklahoma-county-poi-extreme-high";
export const COUNTY_POI_EXTREME_LOW_LAYER_ID = "oklahoma-county-poi-extreme-low";
export const ZIP_POI_COMBINED_LAYER_ID = "tulsa-zip-poi-combined";
export const COUNTY_POI_COMBINED_LAYER_ID = "oklahoma-county-poi-combined";
